module.exports = __webpack_public_path__ + "static/media/png.d41885b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/png.svg
// module id = 1670
// module chunks = 17